import React, { useEffect } from 'react';
import windowService from '../../services/windowService';
import { useLogin } from './hooks/useLogin';
import { ContainerFluid } from '../../components/Layout';
import LoadingState from '../../components/LoadingState';
import { localStorage } from '../../utils/storageUtils';

export function Logout() {
  const { redirectToLogin, redirectToRegister, logoutUser } = useLogin(false);

  useEffect(() => {
    const redirectData = localStorage.getItem('redirectToLifeWay');

    if (redirectData) {
      if (redirectData.cmd === 'login') {
        if (redirectData.redirectURL) {
          sessionStorage.setItem('redirectUrl', redirectData.redirectURL);
        }
        redirectToLogin(redirectData.redirectURL, redirectData.email);
      } else {
        redirectToRegister();
      }
    } else {
      // User has landed on the logout page, so we will log them out manually
      logoutUser().catch(() => {
        windowService.redirectTo('/login');
      });
    }
  }, []);

  return (
    <ContainerFluid>
      <LoadingState />
    </ContainerFluid>
  );
}
